module.exports = __webpack_public_path__ + "img/20200201_160818.983fd1f3.jpg";